/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PartnersIntroductionDto } from '../models/PartnersIntroductionDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PartnersIntroductionService {
  /**
   * 협력사 소개 가져오기
   * @returns PartnersIntroductionDto
   * @throws ApiError
   */
  public static partnersIntroductionControllerGetAllPartnersIntroductions(): CancelablePromise<
    Array<PartnersIntroductionDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/partners-introductions',
    });
  }
}
